<template>
    <div class="page">
        <el-tabs  :tab-position="tabPosition" style="height: 100%;overflow: auto" v-model='tabs'>
            <el-tab-pane label="基本信息" name="first">
                <el-form :model="mallShop" ref="mallShopForm" style='padding-left: 40px;' :rules="rules" label-width="120px">
                    <el-form-item
                        label="店铺名称"
                        prop="shopName"
                    >
                        <el-input
                            size="small"
                            style="width: 400px;"
                            v-model="mallShop.shopName"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="店铺位置" prop="shopAddress">
                        <location
                            style="width: 400px;"
                            :areaTreeDate="areaTreeDate"
                            :longitude="mallShop.shopPosition.split(',')[0]"
                            :latitude="mallShop.shopPosition.split(',')[1]"
                            :provinceId="mallShop.provinceId"
                            :cityId="mallShop.cityId"
                            :areaId="mallShop.areaId"
                            :address="mallShop.shopAddress"
                            @getLocation="getLocation"
                        ></location>
                    </el-form-item>
                    <el-form-item
                        label="所属省份"
                        prop="provinceId"
                    >
                        <el-select
                            placeholder="请选择省"
                            @change="clearSubitem('province')"
                            clearable
                            style="width: 400px"
                            size="small"
                            v-model="mallShop.provinceId"
                        >
                            <el-option
                                v-for='(item,index) in provinceArry'
                                :key='index'
                                :label="item.areaName"
                                :value="item.id"
                            >
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item
                        label="所属城市"
                        prop="cityId"
                    >
                        <el-select
                            placeholder="请选择市"
                            @change="clearSubitem('city')"
                            clearable
                            style="width: 400px"
                            size="small"
                            v-model="mallShop.cityId"
                        >
                            <el-option
                                v-for='(item,index) in cityArry'
                                :key='index'
                                :label="item.areaName"
                                :value="item.id"
                            >
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item
                        label="所属区县"
                        prop="areaId"
                    >
                        <el-select
                            placeholder="请选择区"
                            clearable
                            style="width: 400px"
                            size="small"
                            v-model="mallShop.areaId"
                        >
                            <el-option
                                v-for='(item,index) in areaArry'
                                :key='index'
                                :label="item.areaName"
                                :value="item.id"
                            >
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item
                        label="店铺位定"
                        prop="shopPosition"
                    >
                        <el-input
                            size="small"
                            style="width: 400px;"
                            v-model="mallShop.shopPosition"
                        ></el-input>
                    </el-form-item>
                    <el-form-item
                        label="营业时间"
                        prop="openHours"
                    >
                        <el-time-picker
                            is-range
                            style="width: 400px;"
                            v-model="mallShop.openHours"
                            range-separator="至"
                            format='HH:mm:ss'
                            value-format='HH:mm:ss'
                            start-placeholder="开始时间"
                            end-placeholder="结束时间"
                            placeholder="选择时间范围">
                        </el-time-picker>
                    </el-form-item>
                    <el-form-item
                        label="联系人姓名"
                        prop="contactPerson"
                    >
                        <el-input
                            size="small"
                            style="width: 400px;"
                            v-model="mallShop.contactPerson"
                        ></el-input>
                    </el-form-item>
                    <el-form-item
                        label="联系人电话"
                        prop="contactPhone"
                    >
                        <el-input
                            size="small"
                            style="width: 400px;"
                            v-model="mallShop.contactPhone"
                        ></el-input>
                    </el-form-item>
                    <!--el-form-item
                        label="积分抵扣"
                        prop="contactPhone"
                    >
                        <el-input
                            size="small"
                            style="width: 400px;"
                            v-model="mallShop.scoreDiscount"
                        ></el-input>
                    </el-form-item-->
                    <el-form-item
                        label="店铺管理"
                        prop="userId"
                    >
                        <GridSelectU
                            style='width: 400px'
                            title='选择用户'
                            labelName='userName'
                            labelValue='id'
                            :value='mallShop.userId'
                            :limit='1'
                            size='small'
                            placeholder='请选择用户'
                            @getValue='getValueUserId'
                            :columns="USER_code"
                            :searchs="USER_search"
                            dataListUrl='/mpp/user/findList'
                            entityBeanName='mppUser'
                            queryEntityUrl='/mpp/user/get'
                        >
                        </GridSelectU>
                    </el-form-item>
<!--                    <el-form-item-->
<!--                        label="可以供货"-->
<!--                        prop="canSupply"-->
<!--                    >-->
<!--                        <el-select-->
<!--                            placeholder="请选择是否可以供货"-->
<!--                            clearable-->
<!--                            style="width: 400px"-->
<!--                            size="small"-->
<!--                            v-model="mallShop.canSupply"-->
<!--                        >-->
<!--                            <el-option-->
<!--                                v-for='(item,index) in yesNoEnumList'-->
<!--                                :key='index'-->
<!--                                :label="item.value"-->
<!--                                :value="item.key"-->
<!--                            >-->
<!--                            </el-option>-->
<!--                        </el-select>-->
<!--                    </el-form-item>-->
                    <el-form-item
                        label="销售模式"
                        prop="saleMode"
                    >
                        <el-select
                            placeholder="请选择销售模式"
                            clearable
                            style="width: 400px"
                            size="small"
                            v-model="mallShop.saleMode"
                        >
                            <el-option
                                v-for='(item,index) in saleModeEnumList'
                                :key='index'
                                :label="item.value"
                                :value="item.key"
                            >
                            </el-option>
                        </el-select>
                    </el-form-item>
<!--                    <el-form-item-->
<!--                        label="批发价格"-->
<!--                        prop="wholesalePrice"-->
<!--                        v-if="mallShop.saleMode == 3"-->
<!--                    >-->
<!--                        <el-input-->
<!--                            size="small"-->
<!--                            style="width: 400px;"-->
<!--                            v-model="mallShop.wholesalePrice"-->
<!--                        ></el-input>-->
<!--                    </el-form-item>-->
<!--                    <el-form-item-->
<!--                        label="起批数量"-->
<!--                        prop="buyMinLimit"-->
<!--                        v-if="mallShop.saleMode == 3"-->
<!--                    >-->
<!--                        <el-input-->
<!--                            size="small"-->
<!--                            style="width: 400px;"-->
<!--                            v-model="mallShop.buyMinLimit"-->
<!--                        ></el-input>-->
<!--                    </el-form-item>-->
                </el-form>
            </el-tab-pane>
            <el-tab-pane label="审核信息" name="two">
                <el-form :model="mallShop" ref="mallShopForm1" style='padding-left: 40px;' :rules="rules" label-width="120px">
                    <el-form-item
                        label='申请人姓名'
                        prop='applyName'
                    >
                        <el-input
                            size='small'
                            style='width: 400px;'
                            v-model='mallShop.applyName'
                        ></el-input>
                    </el-form-item>
                    <el-form-item
                        label='申请公司名称'
                        prop='applyCompany'
                    >
                        <el-input
                            size='small'
                            style='width: 400px;'
                            v-model='mallShop.applyCompany'
                        ></el-input>
                    </el-form-item>

                    <el-form-item
                        label="店铺LOGO"
                        prop="shopLogo"
                    >
                        <el-upload
                            style="width: 400px"
                            class="avatar-uploader"
                            action=""
                            :show-file-list="false"
                            :http-request="uploadShopLogo"
                        >
                            <img v-if="mallShop.shopLogo" :src="mallShop.shopLogo" class="avatar" size="small" />
                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        </el-upload>
                    </el-form-item>
                    <el-form-item
                        label='店铺BANNER'
                        prop='shopBanner'
                    >
                        <el-upload
                            style='width: 400px'
                            class='avatar-uploader'
                            action=''
                            :show-file-list='false'
                            :http-request='uploadBanner'
                        >
                            <img v-if='mallShop.shopBanner' :src='mallShop.shopBanner' class='avatar' size='small' />
                            <i v-else class='el-icon-plus avatar-uploader-icon'></i>
                        </el-upload>
                    </el-form-item>
                    <el-form-item
                        label='身份证正面'
                        prop='idcardFront'
                    >
                        <el-upload
                            style='width: 400px'
                            class='avatar-uploader'
                            action=''
                            :show-file-list='false'
                            :http-request='uploadIdcardFront'
                        >
                            <img v-if='mallShop.idcardFront' :src='mallShop.idcardFront' class='avatar' size='small' />
                            <i v-else class='el-icon-plus avatar-uploader-icon'></i>
                        </el-upload>
                    </el-form-item>
                    <el-form-item
                        label='身份证反面'
                        prop='idcardBack'
                    >
                        <el-upload
                            style='width: 400px'
                            class='avatar-uploader'
                            action=''
                            :show-file-list='false'
                            :http-request='uploadIdcardBack'
                        >
                            <img v-if='mallShop.idcardBack' :src='mallShop.idcardBack' class='avatar' size='small' />
                            <i v-else class='el-icon-plus avatar-uploader-icon'></i>
                        </el-upload>
                    </el-form-item>
                    <el-form-item
                        label='公司营业执照'
                        prop='companyLicense'
                    >
                        <el-upload
                            style='width: 400px'
                            class='avatar-uploader'
                            action=''
                            :show-file-list='false'
                            :http-request='uploadCompanyLicense'
                        >
                            <img v-if='mallShop.companyLicense' :src='mallShop.companyLicense' class='avatar' size='small' />
                            <i v-else class='el-icon-plus avatar-uploader-icon'></i>
                        </el-upload>
                    </el-form-item>
                </el-form>
            </el-tab-pane>
        </el-tabs>
        <div class="bottm-btn">
            <el-button style="margin-left: 30px" type="primary" @click="submitForm">确认添加</el-button>
        </div>
    </div>
</template>
<script>
import Location from '@/components/location/location.vue';
import Tag from '@/components/tag/tag.vue'
import GridSelectU from '@/components/gridselect';
import GridSelect from '@/components/gridselect/brand.vue';
import { get, post, deleteFun, upload } from '@/utils/request.js';
import { UPLOAD_API, UPLOAD_PATH, USER, USER_SEARCH } from '@/utils/constant.js';

export default {
    components: {
        GridSelect,
        GridSelectU,
        Location,
        Tag
    },
    data() {
        return {
            USER_code: USER,
            USER_search: USER_SEARCH,
            tabs:'first',
            areaTreeDate: [],
            yesNoEnumList: [],

            header: {
                token: localStorage.getItem('token')
            },
            action: UPLOAD_API + UPLOAD_PATH,
            fileList: [],
            temporaryList: [],
            albumList: '',

            tabPosition: 'left',
            mapDialog: false,
            mallShop: {
                shopName: '', //店铺名称
                shopLogo: '', //店铺logo
                shopBanner: '', //店铺banner
                provinceId: '', //省
                cityId: '', //市
                areaId: '', //区
                shopAddress: '', //详细地址
                shopPosition: '', //位定
                openHours: ['08:00:00','20:00:00'], //营业时间
                contactPerson: '', //联系人
                contactPhone: '', //联系电话
                scoreDiscount: 0, //积分折扣
                saleMode: 1, //是否可以供货
                applyName: '', //申请人姓名
                idcardFront: '', //申请人身份证正面
                idcardBack: '', //申请人身份证反面
                applyCompany: '', //申请公司名称
                companyLicense: '', //公司营业执照
                // remarks: '', //备注
                // paymentCode: '', //收款码
                userId: '', //店铺管理
                status: 2, //核审状态
                wholesalePrice: '',
                buyMinLimit: ''
            },
            rules: {
                shopName: [{ required: true, message: '店铺名称不能为空', trigger: 'blur' }],
                shopLogo: [{ required: true, message: '店铺logo不能为空', trigger: 'blur' }],
                shopBanner: [{ required: true, message: '店铺banner不能为空', trigger: 'blur' }],
                provinceId: [{ required: true, message: '省不能为空', trigger: 'blur' }],
                cityId: [{ required: true, message: '市不能为空', trigger: 'blur' }],
                areaId: [{ required: true, message: '区不能为空', trigger: 'blur' }],
                shopAddress: [{ required: true, message: '详细地址不能为空', trigger: 'blur' }],
                shopPosition: [{ required: true, message: '位定不能为空', trigger: 'blur' }],
                openHours: [{ required: true, message: '营业时间不能为空', trigger: 'blur' }],
                contactPerson: [{ required: true, message: '联系人不能为空', trigger: 'blur' }],
                contactPhone: [{ required: true, message: '联系电话不能为空', trigger: 'blur' }],
                scoreDiscount: [{ required: true, message: '积分抵扣不能为空', trigger: 'blur' }],
                saleMode: [{ required: true, message: '销售模式不能为空', trigger: 'blur' }],
                applyName: [{ required: true, message: '申请人姓名不能为空', trigger: 'blur' }],
                idcardFront: [{ required: true, message: '申请人身份证正面不能为空', trigger: 'blur' }],
                idcardBack: [{ required: true, message: '申请人身份证反面不能为空', trigger: 'blur' }],
                applyCompany: [{ required: true, message: '申请公司名称不能为空', trigger: 'blur' }],
                companyLicense: [{ required: true, message: '公司营业执照不能为空', trigger: 'blur' }],
                remarks: [{ required: true, message: '备注不能为空', trigger: 'blur' }],
                paymentCode: [{ required: true, message: '收款码不能为空', trigger: 'blur' }],
                userId: [{ required: true, message: '店铺管理不能为空', trigger: 'blur' }],
                status: [{ required: true, message: '核审状态不能为空', trigger: 'blur' }],
                createTime: [{ required: true, message: '创建时间不能为空', trigger: 'blur' }],
                wholesalePrice: [{ required: true, message: '批发价格不能为空', trigger: 'blur' }],
                buyMinLimit: [{ required: true, message: '起批数量不能为空', trigger: 'blur' }],
            },
            saleModeEnumList: []
        };
    },
    created() {
        this.getTreeData();
        this.getYesNoEnum();
        this.getSaleModeEnumList();
    },
    computed:{
        provinceArry(){
            return this.areaTreeDate
        },
        cityArry(){
            if(!this.provinceArry){
                return []
            } else {
                for (let i = 0; i < this.provinceArry.length; i++) {
                    if(this.provinceArry[i].id == this.mallShop.provinceId){
                        return this.provinceArry[i].children
                    } else if (this.mallShop.provinceId == "") {
                        return []
                    }
                }
            }
        },
        areaArry(){
            if(!this.cityArry){
                return []
            } else {
                for (let i = 0; i < this.cityArry.length; i++) {
                    if(this.cityArry[i].id == this.mallShop.cityId){
                        return this.cityArry[i].children
                    }
                }
            }
        },
    },
    methods:{
        getSaleModeEnumList(){
            get('/mpp/utils/getEnum',{
                enumType: 'sale_mode',
            }).then((res)=>{
                if(res.success){
                    this.saleModeEnumList = res.enumList
                }
            })
        },
        submitForm() {
            let bool = true
            this.$refs.mallShopForm.validate((valid) => {
                if(!valid){
                    bool = false
                    this.tabs = "first"
                    this.$message({
                        message: "请完善基本信息",
                        type: 'error',
                        duration: 2000,
                    });
                    return
                }
            })
            if(!bool){
                return
            }
            this.$refs.mallShopForm1.validate((valid) => {
                if(!valid){
                    bool = false
                    this.tabs = "two"
                    this.$message({
                        message: "请完善审核信息",
                        type: 'error',
                        duration: 2000,
                    });
                }
            })
            if(!bool){
                return
            }
            if(bool){
                console.log('submit');
                this.mallShop.openHours = this.mallShop.openHours.join('-')
                post(`/restaurant/shop/add`,{ ...this.mallShop }).then((res) => {
                    if (res.success && res.code == 200) {
                        this.$router.push('/restaurant/MallShop');
                        this.$message({
                            message: res.msg,
                            type: 'success',
                            duration: 2000,
                        });
                    } else {
                        this.mallShop.openHours = this.mallShop.openHours.split('-')
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000,
                        });
                    }
                });
            }
        },
        //上传LOGO
        uploadShopLogo(params) {
            const file = params.file;
            let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
            if (!types.includes(file.type)) {
                this.$message.error('图片类型错误!');
            }
            const formData = new FormData();
            formData.append('file', file);
            upload(UPLOAD_PATH, formData).then((res) => {
                if (res.success) {
                    this.mallShop.shopLogo = res.url;
                }
            });
        },
        //上传banner
        uploadBanner(params) {
            const file = params.file;
            let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
            if (!types.includes(file.type)) {
                this.$message.error('图片类型错误!');
            }
            const formData = new FormData();
            formData.append('file', file);
            upload(UPLOAD_PATH, formData).then((res) => {
                if (res.success) {
                    this.mallShop.shopBanner = res.url;
                    console.log('this.mallShop.shopBanner',this.mallShop.shopBanner)
                }
            });
        },

        //上传身份证正面
        uploadIdcardFront(params) {
            const file = params.file;
            let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
            if (!types.includes(file.type)) {
                this.$message.error('图片类型错误!');
            }
            const formData = new FormData();
            formData.append('file', file);
            upload(UPLOAD_PATH, formData).then((res) => {
                if (res.success) {
                    this.mallShop.idcardFront = res.url;
                }
            });
        },

        // 上传身份证反面
        uploadIdcardBack(params) {
            const file = params.file;
            let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
            if (!types.includes(file.type)) {
                this.$message.error('图片类型错误!');
            }
            const formData = new FormData();
            formData.append('file', file);
            upload(UPLOAD_PATH, formData).then((res) => {
                if (res.success) {
                    this.mallShop.idcardBack = res.url;
                }
            });
        },

        // 上传公司营业执照
        uploadCompanyLicense(params) {
            const file = params.file;
            let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
            if (!types.includes(file.type)) {
                this.$message.error('图片类型错误!');
            }
            const formData = new FormData();
            formData.append('file', file);
            upload(UPLOAD_PATH, formData).then((res) => {
                if (res.success) {
                    this.mallShop.companyLicense = res.url;
                }
            });
        },

        handleRemove(file, fileList) {
            for (let i = 0; i < this.temporaryList.length; i++) {
                if (file.response.url == this.temporaryList[i]) {
                    this.temporaryList.splice(i, 1);
                }
            }
            this.albumList = this.temporaryList.join('|');
        },
        handleSuccess(response, file, fileList) {
            this.temporaryList.push(file.response.url);
            this.albumList = this.temporaryList.join('|');
        },
        beforeAvatarUpload(file) {
            const isLt2M = file.size / 1024 / 1024 < 50;
            if (!isLt2M) {
                this.$message.error('上传头像图片大小不能超过 50MB!');
            }
            return isLt2M;
        },
        getTreeData(){
            get('/mpp/area/treeData').then((res)=>{
                if(res.success){
                    this.areaTreeDate = res.treeData[0].children
                }
            })
        },
        // 获取yes_no枚举
        getYesNoEnum(){
            get('/mpp/utils/getEnum',{
                enumType: 'yes_no',
            }).then((res)=>{
                if(res.success){
                    this.yesNoEnumList = res.enumList
                }
            })
        },
        getLocation(location){
            this.mallShop.shopPosition = `${location.lng},${location.lat}`
            this.mallShop.shopAddress = location.address
            this.mallShop.provinceId = location.province
            this.mallShop.cityId = location.city
            this.mallShop.areaId = location.area
        },
        clearSubitem(id){
            if (id == 'province'){
                this.mallShop.cityId = ""
                this.mallShop.areaId = ""
            } else if (id == 'city') {
                this.mallShop.areaId = ""
            }
        },
        getValueUserId(value){
            this.mallShop.userId = value
        },
    }
};
</script>
<style scoped lang="scss">
.page{
    width: 100%;
    height: 100%;
    background-color: #fff;
    padding: 30px;
}
.bottm-btn{
    margin-top: 20px;
    padding-left: 100px;
}
.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}
.avatar-uploader-icon {
    font-size: 30px;
    color: #8c939d;
    width: 400px;
    height: 200px;
    line-height: 200px;
    text-align: center;
}
.avatar {
    width: 400px;
    height: 200px;
    display: block;
}
::v-deep .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 400px;
    height: 200px;
}
.avatarWide {
    width: 200px;
    height: 120px;
}

</style>